import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { newCountryComponent } from './@pages/country/new/new-country.component';
import { PagesComponent } from './@pages/pages.component';
import { NewProvinceComponent } from './@pages/province/new/new-province.component';
import { NewTownComponent } from './@pages/town/new/new-town.component';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { ChangePassComponent } from './change-pass/change-pass.component';
import { ForgottenComponent } from './forgotten-pass/forgotten-pass.component';
import { LoginGuard } from './guards/login.guard';
import { LogoutGuard } from './guards/logout.guard';
import { TokenGuard } from './guards/token.guard';
import { LoginComponent } from './login/login.component';
import { PagesNotFoundComponent } from './pages-not-found/pages-not-found.component';

const routes: Routes = [
  // Rutas de autenticación
  { path: 'login', component: LoginComponent, canActivate: [LogoutGuard] },
  { path: 'changePass', component: ChangePassComponent },
  { path: 'forgottenPass', component: ForgottenComponent },
  { path: 'activateUser', component: ActivateUserComponent },
  { path: 'activate-user', component: ActivateUserComponent },
  { path: 'activateuser', component: ActivateUserComponent },

  // Rutas principales que cargan módulos hijos en el outlet principal
  {
    path: '',
    component: PagesComponent,
    canActivate: [LoginGuard, TokenGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', loadChildren: () => import('./@pages/home/home.module').then(m => m.HomeModule) },
      { path: 'fichar', loadComponent: () => import('./@pages/work-shift/work-shift-page.component').then(m => m.WorkShiftPageComponent) },
      { path: 'fichajes', loadComponent: () => import('./@pages/work-shift/work-shift-admin-page.component').then(m => m.WorkShiftAdminPageComponent) },
      { path: 'countries', loadChildren: () => import("./@pages/country/country.module").then(m => m.ListModule) },
      { path: 'provinces', loadChildren: () => import('./@pages/province/province.module').then(m => m.ProvinceModule) },
      { path: 'towns', loadChildren: () => import('./@pages/town/list-towns.module').then(m => m.ListTownsModule) },
      { path: 'customers', loadChildren: () => import('./@pages/customer/customer.module').then(m => m.CustomerListModule) },
      { path: 'materials', loadChildren: () => import('./@pages/material/material.module').then(m => m.NewMaterialModule) },
      { path: 'budgets', loadChildren: () => import('./@pages/budget/budgets.module').then(m => m.BudgetsModule) },
      { path: 'delivery', loadChildren: () => import('./@pages/delivery/delivery.module').then(m => m.DeliveryListModule) },
      { path: 'invoices', loadChildren: () => import('./@pages/invoice/invoice.module').then(m => m.InvoiceModule) },
      { path: 'cuenta', loadChildren: () => import('./@pages/invoice/cuentas/cuentas.module').then(m => m.CuentasModule) },
      { path: 'user', loadChildren: () => import('./@pages/user/user.module').then(m => m.UserModule) },
      { path: 'personal', loadChildren: () => import('./@pages/personal/personal.module').then(m => m.PersonalModule) },
      { path: 'inventario', loadChildren: () => import('./@pages/inventario/inventario.module').then(m => m.InventarioModule) },
      { path: 'inventario/category', loadChildren: () => import('./@pages/inventario/category/category.module').then(m => m.CategoryModule) },
      { path: 'inventario/categoria', loadChildren: () => import('./@pages/inventario/category/category.module').then(m => m.CategoryModule) },
      { path: 'inventario/range', loadChildren: () => import('./@pages/inventario/range/range.module').then(m => m.RangeModule) },
      { path: 'informes', loadChildren: () => import('./@pages/informes/informes.module').then(m => m.InformesModule) },
      { path: 'recursos', loadChildren: () => import('./@pages/recursos/recursos.module').then(m => m.RecursosModule) },
      { path: 'scan', loadChildren: () => import('./@pages/scan/scan.module').then(m => m.ScanModule) },
    ]
  },

    // Rutas auxiliares para el outlet "sidebar"
  { path: 'new-country', component: newCountryComponent, outlet: 'sidebar', canActivate: [LoginGuard] },
  { path: 'new-province', component: NewProvinceComponent, outlet: 'sidebar', canActivate: [LoginGuard] },
  { path: 'new-town', component: NewTownComponent, outlet: 'sidebar', canActivate: [LoginGuard] },


  // Redireccionamientos y manejo de páginas no encontradas
  { path: '**', pathMatch: 'full', component: PagesNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
